export const SET_LOCATION_FILTER = "filters/SET_LOCATION_FILTER";
export const SET_TIME_RANGE_FILTER = "filters/SET_TIME_RANGE_FILTER";
export const SET_WIDGET_FILTER = "filters/SET_WIDGET_FILTER";
export const REMOVE_WIDGET_FILTER = "filters/REMOVE_WIDGET_FILTER";
export const CLEAR_WIDGET_FILTER = "filters/CLEAR_WIDGET_FILTER";
export const SET_DROPDOWN_FILTERS = "filters/SET_DROPDOWN_FILTERS";
export const SET_DATE_RANGE_FILTER_WITH_LOCATIONS =
  "filters/SET_DATE_RANGE_FILTER_WITH_LOCATIONS";
export const SET_DATE_TIME_FILTER = "filters/SET_DATE_TIME_FILTER";
export const SET_URL_DATE_VALIDATED = "filters/SET_URL_DATE_VALIDATED";
